import { useState } from "react";
import { updateChildReelGradeValue } from "../../services/productionService";

export const useGradeChanges = () => {
    const [isLoading, setIsLoading] = useState(false);
    const updateChildRollGrade = async (company_id, plant_id, id_product, grade) => {

        // need company_id , plant_id, id_product, grade
        const para = {
            p_companyid: company_id,
            p_plantid: plant_id,
            p_product_id: id_product,
            p_grade: grade
        };
        setIsLoading(true);
        try {
            const todayData = await updateChildReelGradeValue(para);

            setIsLoading(false);
            return todayData || [];
        } catch (error) {
            alert(error.message);
            setIsLoading(false);
        }
    };
    return {
        isLoading,
        updateChildRollGrade,
    };
};